// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Ingredients_wrapper__1rOPd","productDetail":"Ingredients_productDetail__3IWJ5","image":"Ingredients_image__rlzmU"};